var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$invoice.hasPendingPayments)?_c('u-message',{attrs:{"icon":"hourglass-start","type":"is-warning"}},[_c('i18n',{attrs:{"path":_vm.$invoice.isPayable
        ? '_sentence.invoice.due_with_pending_payments_msg'
        : '_sentence.invoice.not_due_with_pending_payments_msg'}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }